// extracted by mini-css-extract-plugin
export default {"nav-link-item":"Header_nav-link-item__SkMmH"};